import LiberarProvisoesPagamentoLista from './componentes/LiberarProvisoesPagamentoLista.vue';

export default {
  path: '/liberar-provisoes-pagamento',
  component: LiberarProvisoesPagamentoLista,
  meta: { auth: true },
  name: 'liberar-provisoes-pagamento',
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/liberar-provisoes-pagamento/rotas.js